import { Helmet } from 'react-helmet';
import { AdminDashboard } from 'src/components/AdminDashboard';

const AdminDashboardPage = () => (
  <>
    <Helmet>
      <title> Admin Dashboard</title>
    </Helmet>

    <AdminDashboard />
  </>
);

export default AdminDashboardPage;
